import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    height: 70,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.facet.lightGray3}`,
  },
  dayText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 44,
    height: 44,
    color: theme.palette.facet.primaryGray,
    fontWeight: 'bold',
  },
  selectedDay: {
    borderRadius: '50%',
    backgroundColor: theme.palette.facet.accentBlue,
    color: theme.palette.common.white,
  },
});

const DayDisplayRow = ({
  className,
  classes,
  daysInWeek,
  selectedDate,
}) => {
  return (
    <div className={classNames(className, classes.root)}>
      {daysInWeek.map(day => (
        <div className={classNames(classes.dayText, {
          [classes.selectedDay]: selectedDate?.isSame(day, 'day'),
        })}
        >
          {day.format('D')}
        </div>
      ))}
    </div>
  );
};

DayDisplayRow.defaultProps = {
  className: '',
  selectedDate: null,
};

DayDisplayRow.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  daysInWeek: PropTypes.array.isRequired,
  selectedDate: PropTypes.object,
};

export default withStyles(styles)(DayDisplayRow);
